import { SearchOutlined } from "@ant-design/icons";
import {
  BaseSelect,
  SelectOption,
} from "components/AntDesign/Select/BaseSelect";

type Props = {
  options: SelectOption<number>[];
  value?: number;
  loading?: boolean;
  disabled?: boolean;
  onChange: (value?: number) => void;
  onSearch?: (value: string) => void;
};

export function CategorySelector({
  options,
  value,
  loading,
  disabled,
  onChange,
  onSearch,
}: Props) {
  return (
    <BaseSelect<number>
      options={options}
      value={value}
      onChange={onChange}
      onSearch={onSearch}
      prefix={<SearchOutlined />}
      loading={loading}
      disabled={disabled}
      float={{ label: "Select category" }}
    />
  );
}
